import TabaPayLimitInfo from 'features/moveMoney/screens/dcf/tabapay/TabapayTransfer/TabaPayLimitInfo';
import React from 'react';

export default function TabaPayLimitInfoPage() {
  return <TabaPayLimitInfo />;
}
